module.exports = __webpack_public_path__ + "media/icons/re_white-cabc0c08.png";